import { render, staticRenderFns } from "./c-db-export-btn.vue?vue&type=template&id=4e8a68d0&"
import script from "./c-db-export-btn.vue?vue&type=script&lang=js&"
export * from "./c-db-export-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports